import React from 'react';
import InspectionResultsAddEditModal from './inspectionresults-add-edit';

import { MODAL_TYPES } from 'Feature/components/app-modals';
import { selectedPart } from './store/selectors';
import { useSelector } from 'react-redux';

const { INSPECTIONRESULTS_ADD_EDIT } = MODAL_TYPES;

const InspectionResultsModals = () => {
  const currentSelectedPart = useSelector(selectedPart);
  return (
    <>
      <InspectionResultsAddEditModal
        selectedPart={currentSelectedPart}
        modalId={INSPECTIONRESULTS_ADD_EDIT}
      />
    </>
  );
};

export default InspectionResultsModals;
